export const createUploadDropzoneHandlers = ({
    selectedUploadFile,
    clearUploadFileSelection,
    setIsDragging,
    handleFileChange,
}) => {
    const stopDropzoneEvent = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    return {
        handleRemoveUploadFile: (event) => {
            stopDropzoneEvent(event);
            clearUploadFileSelection();
        },
        handleUploadDragEnter: (event) => {
            stopDropzoneEvent(event);
            if (selectedUploadFile) return;
            setIsDragging(true);
        },
        handleUploadDragOver: (event) => {
            stopDropzoneEvent(event);
            if (selectedUploadFile) return;
            setIsDragging(true);
        },
        handleUploadDragLeave: (event) => {
            stopDropzoneEvent(event);
            if (!event.currentTarget.contains(event.relatedTarget)) {
                setIsDragging(false);
            }
        },
        handleUploadDrop: (event) => {
            stopDropzoneEvent(event);
            setIsDragging(false);
            if (selectedUploadFile) return;
            handleFileChange(event.dataTransfer.files?.[0] || null);
        },
    };
};
